// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"c984f40e","78":"0267ae41","304":"13f35ec1","432":"4bf6b54a","447":"edd851f6"}[chunkId] + ".chunk.js";
};